import React, { useMemo, useState } from 'react';
import { TreeNode } from './TreeNode';
import { TreeItem } from './types';
import { buildTree } from './utils';

export interface TreeProps<T> {
  items: TreeItem<T>[];
  defaultExpandAll?: boolean;
  renderLabel: (data: T, item?: TreeItem<T>) => React.ReactNode;
  renderLeaf?: (data: T) => React.ReactNode;
  onItemClick?: (item: TreeItem<T>) => void;
  selectedId?: string;
  className?: string;
}

export const Tree = <T,>({
  items,
  renderLabel,
  renderLeaf,
  defaultExpandAll = false,
  onItemClick,
  selectedId,
  className = '',
}: TreeProps<T>) => {
  const [openFolders, setOpenFolders] = useState<Set<string>>(
    () => new Set(defaultExpandAll ? items.map((el) => el.id) : []),
  );

  const treeData = useMemo(() => buildTree(items), [items]);

  const toggle = (id: string) => {
    setOpenFolders((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  return (
    <ul className={`${className}`} style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {treeData.map((item) => (
        <TreeNode
          key={item.id}
          item={item}
          level={0}
          isOpen={openFolders.has(item.id)}
          toggle={toggle}
          renderLabel={renderLabel}
          renderLeaf={renderLeaf}
          openFolders={openFolders}
          onItemClick={onItemClick}
          selectedId={selectedId}
        />
      ))}
    </ul>
  );
};
